import axios from '@/services/axios';

export const api = {
  getDynamicPaperUrl: '/information/v1/ObtainUpdatesOnTheFieldOfThePaper', // 获取论文领域动态
  getDynamicNewsUrl: '/information/v1/GetUpdatesOnTheInformationField', // 获取资讯领域动态
  getDynamicNewsUrlv2: '/information/v1/GetUpdatesOnTheInformationFieldv2', // 获取资讯领域动态
  getSubscriptStatusUrl: '/information/v1/obtainUserSubscriptionStatus', // 获取用户订阅状态、绑定的邮箱地址
  addSubscriptUrl: '/information/v1/createSubscription', // 创建订阅
  delSubscriptUrl: '/information/v1/cancelSubscription', // 取消订阅
  addBriefUrl: '/information/v1/addBriefingPubs', // 添加到简报
  delBriefUrl: '/information/v1/removeBriefing', // 添加到简报
  addGenBriefUrl: '/information/v1/generateBriefing', // 生成简报
  updBriefUrl: '/information/v1/reGenerateBriefing', // 重新生成简报
  getBriefListUrl: '/information/v1/obtainBriefingList', // 获取简报列表
  getBriefingPubsListUrl: '/information/v1/obtainBriefingPubsList', // 获取简动态
  delBriefingPubsListUrl: '/information/v1/removeBriefingPubsList', // 从简报动态列表移除
  bindEmailUrl: '/aminer-api/api/v0/user/bind', // 获取绑定邮箱
  updEmailUrl: '/aminer-api/api/v0/user/bind', //  更新绑定邮箱
  delEmailUrl: '/aminer-api/api/v0/user/unBind', //  删除绑定邮箱
  getBindUrl: '/information/v1/obtainUserSubscriptionStatus', //  获取用户订阅状态、绑定的邮箱地址
  checkEmailUrl: 'https://api-egg.top3-talent.com/api/oauth/email/checkExists', // 校验邮箱
  sendEmailCodeByRegisterUrl: 'https://api-egg.top3-talent.com/api/oauth/sendCodeToEmailByRegister', // 发送邮箱验证吗
  // http://trend-beta.aminer.cn/microtrend-api/aminer-api/api/v0/user/bind
};

export async function postDataService(params: any, apiUrl: string) {
  // const result = requestJson(api[apiUrl], {
  //   method: 'post',
  //   payload: params,
  // });
  // return result;
  return axios.post(api[apiUrl], params);
}

export async function getDataService(params: any, apiUrl: string, contentType?: any) {
  // const result = requestJson(
  //   api[apiUrl],
  //   {
  //     method: 'get',
  //     payload: params,
  //   },
  //   contentType,
  // );
  // return result;
  const result = axios({ method: 'get', url: api[apiUrl], params });
  return result;
}
